// Map configuration constants
export const MAP_CONFIG = {
    ZOOM_FACTOR_IN: 0.5,
    ZOOM_FACTOR_OUT: 2,
} as const;

// Color thresholds for country allocations
export const COLOR_THRESHOLDS = {
    VERY_HIGH: 50, // 50%+
    HIGH: 30, // 30-50%
    MEDIUM: 15, // 15-30%
    LOW: 5, // 5-15%
    // Below 5% gets the lightest color
} as const;

export const UNAVAILABLE_COUNTRY_CODE = "Unavailable";

export const MAP_CHART_WIDTH = ["100%", "327px", "327px", "382px"];
